export const details = [
    {
        title: "Invoice",
        content: [
            {create: false, delete: false, fk_module_id: 1,
             id: 220, name: "New Invoice", read: false,update: false},
            {create: false,
                delete: false,
                fk_module_id: 2,
                id: 221,
                name: "Manage Invoice",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 3, id: 222, name: "POS INVOICE", read: false,update: false},
            {create: false, delete: false, fk_module_id: 4, id: 223, name: "GUI POS", read: false,update: false},
        ]
    },
    {
        title: "Customer",
        content: [
            {create: false, delete: false, fk_module_id: 27, id: 224, name: "Add Customer", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 28,
                id: 225,
                name: "Manage Customer",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 29,
                id: 226,
                name: "Credit Customer",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 30,
                id: 227,
                name: "Paid Customer",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Medicine",
        content: [
            {create: false, delete: false, fk_module_id: 22, id: 228, name: "Category", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 23,
                id: 229,
                name: "Medicine Type",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 24, id: 230, name: "Add Medicine", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 25,
                id: 231,
                name: "Import Medicine(CSV)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 26,
                id: 232,
                name: "Manage Medicine",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 105, id: 233, name: "Add Unit", read: false,update: false},
            {create: false, delete: false, fk_module_id: 106, id: 234, name: "Unit List", read: false,update: false},
        ]
    },
    {
        title: "Manufacturer",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 31,
                id: 235,
                name: "Add Manufacturer",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 32,
                id: 236,
                name: "Manage Manufacturer",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 33,
                id: 237,
                name: "Manufacturer Ledger",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 34,
                id: 238,
                name: "Manufacturer Sales Details",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Purchase",
        content: [
            {create: false, delete: false, fk_module_id: 35, id: 239, name: "Add Purchase", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 36,
                id: 240,
                name: "Manage Purchase",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 112,
                id: 112,
                name: "Add LPO",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 113,
                id: 113,
                name: "Edit LPO",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 114,
                id: 114,
                name: "Approve LPO",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 115,
                id: 115,
                name: "Cancel LPO",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Stock",
        content: [
            {create: false, delete: false, fk_module_id: 77, id: 241, name: "Stock Report", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 80,
                id: 242,
                name: "Stock Report(Batch Wise)",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Return",
        content: [
            {create: false, delete: false, fk_module_id: 60, id: 243, name: "Return", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 61,
                id: 244,
                name: "Stock Return List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 62,
                id: 245,
                name: "Manufacturer Return List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 63,
                id: 246,
                name: "Wastage Return List",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Report",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 81,
                id: 247,
                name: "Today's Report",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 82, id: 248, name: "Sales Report", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 83,
                id: 249,
                name: "Purchase Report",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 84,
                id: 250,
                name: "Sales Report(Medicine Wise)",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 85, id: 251, name: "Profit/Loss", read: false,update: false},
        ]
    },
    {
        title: "Accounts",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 5,
                id: 252,
                name: "Chart Of Account",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 6,
                id: 253,
                name: "Manufacturer Payment",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 7,
                id: 254,
                name: "Supplier Payment",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 8,
                id: 255,
                name: "Customer Receive",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 9, id: 256, name: "Debit Voucher", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 10,
                id: 257,
                name: "Credit Voucher",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 11,
                id: 258,
                name: "Contra Voucher",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 12,
                id: 259,
                name: "Journal Voucher",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 13,
                id: 260,
                name: "Voucher Approval",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 14, id: 261, name: "Report", read: false,update: false},
            {create: false, delete: false, fk_module_id: 15, id: 262, name: "Cash Book", read: false,update: false},
            {create: false, delete: false, fk_module_id: 16, id: 263, name: "Bank Book", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 17,
                id: 264,
                name: "General Ledger",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 18,
                id: 265,
                name: "Inventory Ledger",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 19, id: 266, name: "Cash Flow", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 20,
                id: 267,
                name: "Profit Loss Statement",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 21,
                id: 268,
                name: "Trial Balance",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 110, id: 269, name: "COA Print", read: false,update: false},
        ]
    },
    {
        title: "Bank",
        content: [
            {create: false, delete: false, fk_module_id: 86, id: 270, name: "Add New Bank", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 87,
                id: 271,
                name: "Bank Transaction",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 88, id: 272, name: "Manage Bank", read: false,update: false},
        ]
    },
    {
        title: "Tax",
        content: [
            {create: false, delete: false, fk_module_id: 72, id: 273, name: "Tax Settings", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 73,
                id: 274,
                name: "Add Income Tax",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 74,
                id: 275,
                name: "Manage Income Tax",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 75, id: 276, name: "Tax Report", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 76,
                id: 277,
                name: "Invoice Wise Tax Report",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Human Resource",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 37,
                id: 278,
                name: "Add Designation",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 38,
                id: 279,
                name: "Manage Designation",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 39, id: 280, name: "Add Employee", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 40,
                id: 281,
                name: "Manage Employee",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 41,
                id: 282,
                name: "Add Attendance",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 42,
                id: 283,
                name: "Manage Attendance",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 43,
                id: 284,
                name: "Attendance Report",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 44, id: 285, name: "Add Benefits", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 45,
                id: 286,
                name: "Manage Benefits",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 46,
                id: 287,
                name: "Add Salary Setup",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 47,
                id: 288,
                name: "Manage Salary Setup",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 48,
                id: 289,
                name: "Salary Generate",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 49,
                id: 290,
                name: "Manage Salary Generate",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 50,
                id: 291,
                name: "Salary Payment",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 51,
                id: 292,
                name: "Add Expense Item",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 52,
                id: 293,
                name: "Manage Expense Item",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 53, id: 294, name: "Add Expense", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 54,
                id: 295,
                name: "Manage Expense",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 55,
                id: 296,
                name: "Add Fixed Assets",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 56,
                id: 297,
                name: "Fixed Asset List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 57,
                id: 298,
                name: "Purchase Fixed Assets",
                read: false,
                update: false
            },
            {
                create: false, delete: false, fk_module_id: 58,
                id: 299,
                name: "Fixed Asset Purchase List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 89,
                id: 300,
                name: "Add Person(Personal Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 90,
                id: 301,
                name: "Manage Person(Personal Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 91,
                id: 302,
                name: "Add Person(Office Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 92,
                id: 303,
                name: "Add Loan(Office Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 93,
                id: 304,
                name: "Add Payment(Office Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 94,
                id: 305,
                name: "Manage Loan(Office Loan)",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Supplier",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 107,
                id: 306,
                name: "Add Supplier",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 108,
                id: 307,
                name: "Manage Supplier",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 109,
                id: 308,
                name: "Supplier Ledger",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Service",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 68,
                id: 309,
                name: "Add Service",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 69,
                id: 310,
                name: "Manage Service",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 70,
                id: 311,
                name: "Service Invoice",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 71,
                id: 312,
                name: "Manage Service Invoice",
                read: false,
                update: false
            },

        ]
    },
    {
        title: "Settings",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 59,
                id: 317,
                name: "Manage Company",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 95,
                id: 318,
                name: "Add User",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 96,
                id: 319,
                name: "Manage Users",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 97,
                id: 320,
                name: "Language",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 98,
                id: 321,
                name: "Currency",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 99,
                id: 322,
                name: "Web Setting",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 100,
                id: 323,
                name: "Add Role",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 101,
                id: 324,
                name: "Role List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 102,
                id: 325,
                name: "Assign User Role",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 103,
                id: 326,
                name: "Permission",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 104,
                id: 327,
                name: "SMS",
                read: false,
                update: false
            }

        ]
    }
];


export const editDetails = [
    {
        title: "Invoice",
        content: [
            {create: false, delete: false, fk_module_id: 1, id: 220, name: "New Invoice", read: false,update: false},
            {create: false, delete: false, fk_module_id: 2, id: 221, name: "Manage Invoice", read: false, update: false},
            {create: false, delete: false, fk_module_id: 3, id: 222, name: "POS INVOICE", read: false,update: false},
            {create: false, delete: false, fk_module_id: 4, id: 223, name: "GUI POS", read: false,update: false},
        ]
    },
    {
        title: "Customer",
        content: [
            {create: false, delete: false, fk_module_id: 27, id: 224, name: "Add Customer", read: false,update: false},
            {create: false, delete: false, fk_module_id: 28, id: 225, name: "Manage Customer", read: false, update: false},
            {create: false, delete: false, fk_module_id: 29, id: 226, name: "Credit Customer", read: false, update: false},
            {create: false, delete: false, fk_module_id: 30, id: 227, name: "Paid Customer", read: false, update: false},
        ]
    },
    {
        title: "Medicine",
        content: [
            {create: false, delete: false, fk_module_id: 22, id: 228, name: "Category", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 23,
                id: 229,
                name: "Medicine Type",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 24, id: 230, name: "Add Medicine", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 25,
                id: 231,
                name: "Import Medicine(CSV)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 26,
                id: 232,
                name: "Manage Medicine",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 105, id: 233, name: "Add Unit", read: false,update: false},
            {create: false, delete: false, fk_module_id: 106, id: 234, name: "Unit List", read: false,update: false},
        ]
    },
    {
        title: "Manufacturer",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 31,
                id: 235,
                name: "Add Manufacturer",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 32,
                id: 236,
                name: "Manage Manufacturer",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 33,
                id: 237,
                name: "Manufacturer Ledger",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 34,
                id: 238,
                name: "Manufacturer Sales Details",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Purchase",
        content: [
            {create: false, delete: false, fk_module_id: 35, id: 239, name: "Add Purchase", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 36,
                id: 240,
                name: "Manage Purchase",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 112,
                id: 112,
                name: "Add LPO",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 113,
                id: 113,
                name: "Edit LPO",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 114,
                id: 114,
                name: "Approve LPO",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 115,
                id: 115,
                name: "Cancel LPO",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Stock",
        content: [
            {create: false, delete: false, fk_module_id: 77, id: 241, name: "Stock Report", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 80,
                id: 242,
                name: "Stock Report(Batch Wise)",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Return",
        content: [
            {create: false, delete: false, fk_module_id: 60, id: 243, name: "Return", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 61,
                id: 244,
                name: "Stock Return List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 62,
                id: 245,
                name: "Manufacturer Return List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 63,
                id: 246,
                name: "Wastage Return List",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Report",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 81,
                id: 247,
                name: "Today's Report",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 82, id: 248, name: "Sales Report", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 83,
                id: 249,
                name: "Purchase Report",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 84,
                id: 250,
                name: "Sales Report(Medicine Wise)",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 85, id: 251, name: "Profit/Loss", read: false,update: false},
        ]
    },
    {
        title: "Accounts",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 5,
                id: 252,
                name: "Chart Of Account",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 6,
                id: 253,
                name: "Manufacturer Payment",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 7,
                id: 254,
                name: "Supplier Payment",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 8,
                id: 255,
                name: "Customer Receive",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 9, id: 256, name: "Debit Voucher", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 10,
                id: 257,
                name: "Credit Voucher",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 11,
                id: 258,
                name: "Contra Voucher",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 12,
                id: 259,
                name: "Journal Voucher",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 13,
                id: 260,
                name: "Voucher Approval",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 14, id: 261, name: "Report", read: false,update: false},
            {create: false, delete: false, fk_module_id: 15, id: 262, name: "Cash Book", read: false,update: false},
            {create: false, delete: false, fk_module_id: 16, id: 263, name: "Bank Book", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 17,
                id: 264,
                name: "General Ledger",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 18,
                id: 265,
                name: "Inventory Ledger",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 19, id: 266, name: "Cash Flow", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 20,
                id: 267,
                name: "Profit Loss Statement",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 21,
                id: 268,
                name: "Trial Balance",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 110, id: 269, name: "COA Print", read: false,update: false},
        ]
    },
    {
        title: "Bank",
        content: [
            {create: false, delete: false, fk_module_id: 86, id: 270, name: "Add New Bank", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 87,
                id: 271,
                name: "Bank Transaction",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 88, id: 272, name: "Manage Bank", read: false,update: false},
        ]
    },
    {
        title: "Tax",
        content: [
            {create: false, delete: false, fk_module_id: 72, id: 273, name: "Tax Settings", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 73,
                id: 274,
                name: "Add Income Tax",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 74,
                id: 275,
                name: "Manage Income Tax",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 75, id: 276, name: "Tax Report", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 76,
                id: 277,
                name: "Invoice Wise Tax Report",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Human Resource",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 37,
                id: 278,
                name: "Add Designation",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 38,
                id: 279,
                name: "Manage Designation",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 39, id: 280, name: "Add Employee", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 40,
                id: 281,
                name: "Manage Employee",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 41,
                id: 282,
                name: "Add Attendance",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 42,
                id: 283,
                name: "Manage Attendance",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 43,
                id: 284,
                name: "Attendance Report",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 44, id: 285, name: "Add Benefits", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 45,
                id: 286,
                name: "Manage Benefits",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 46,
                id: 287,
                name: "Add Salary Setup",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 47,
                id: 288,
                name: "Manage Salary Setup",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 48,
                id: 289,
                name: "Salary Generate",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 49,
                id: 290,
                name: "Manage Salary Generate",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 50,
                id: 291,
                name: "Salary Payment",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 51,
                id: 292,
                name: "Add Expense Item",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 52,
                id: 293,
                name: "Manage Expense Item",
                read: false,
                update: false
            },
            {create: false, delete: false, fk_module_id: 53, id: 294, name: "Add Expense", read: false,update: false},
            {
                create: false,
                delete: false,
                fk_module_id: 54,
                id: 295,
                name: "Manage Expense",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 55,
                id: 296,
                name: "Add Fixed Assets",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 56,
                id: 297,
                name: "Fixed Asset List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 57,
                id: 298,
                name: "Purchase Fixed Assets",
                read: false,
                update: false
            },
            {
                create: false, delete: false, fk_module_id: 58,
                id: 299,
                name: "Fixed Asset Purchase List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 89,
                id: 300,
                name: "Add Person(Personal Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 90,
                id: 301,
                name: "Manage Person(Personal Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 91,
                id: 302,
                name: "Add Person(Office Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 92,
                id: 303,
                name: "Add Loan(Office Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 93,
                id: 304,
                name: "Add Payment(Office Loan)",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 94,
                id: 305,
                name: "Manage Loan(Office Loan)",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Supplier",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 107,
                id: 306,
                name: "Add Supplier",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 108,
                id: 307,
                name: "Manage Supplier",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 109,
                id: 308,
                name: "Supplier Ledger",
                read: false,
                update: false
            },
        ]
    },
    {
        title: "Service",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 68,
                id: 309,
                name: "Add Service",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 69,
                id: 310,
                name: "Manage Service",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 70,
                id: 311,
                name: "Service Invoice",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 71,
                id: 312,
                name: "Manage Service Invoice",
                read: false,
                update: false
            },

        ]
    },
    {
        title: "Settings",
        content: [
            {
                create: false,
                delete: false,
                fk_module_id: 59,
                id: 317,
                name: "Manage Company",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 95,
                id: 318,
                name: "Add User",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 96,
                id: 319,
                name: "Manage Users",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 97,
                id: 320,
                name: "Language",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 98,
                id: 321,
                name: "Currency",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 99,
                id: 322,
                name: "Web Setting",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 100,
                id: 323,
                name: "Add Role",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 101,
                id: 324,
                name: "Role List",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 102,
                id: 325,
                name: "Assign User Role",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 103,
                id: 326,
                name: "Permission",
                read: false,
                update: false
            },
            {
                create: false,
                delete: false,
                fk_module_id: 104,
                id: 327,
                name: "SMS",
                read: false,
                update: false
            }

        ]
    }
];

export const search = [
    {
        create: false,
        delete: false,
        fk_module_id: 64,
        id: 313,
        name: "Medicine",
        read: false,
        update: false
    },
    {
        create: false,
        delete: false,
        fk_module_id: 65,
        id: 314,
        name: "Customer",
        read: false,
        update: false
    },
    {
        create: false,
        delete: false,
        fk_module_id: 66,
        id: 315,
        name: "Invoice",
        read: false,
        update: false
    },
    {
        create: false,
        delete: false,
        fk_module_id: 67,
        id: 316,
        name: "Purchase",
        read: false,
        update: false
    },
];
